
export const HeaderTitle = ({
    attributes

}) => {

    const { faqOptions = {}, faqHeader = {} } = attributes;
    const { displayHeadingTitle, displayHeadingDescription } = faqOptions;



    return (
        <>

            {
                displayHeadingTitle && <h1 className='faq-header-title'>{faqHeader?.title}</h1>
            }

            {
                displayHeadingDescription && <p className='faq-header-subtitle'>
                    {faqHeader?.subTitle}
                </p>
            }

        </>
    )
}
